var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"mb-4"},[_vm._v("Uh Oh!")]),_c('v-card',[_c('v-card-title',[_vm._v("Unknown Error")]),_c('v-divider'),_c('v-card-text',[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" The thing you are trying to do cannot be done. ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }